import { render, staticRenderFns } from "./Invitaciones.vue?vue&type=template&id=469dbb9d&scoped=true"
import script from "./Invitaciones.vue?vue&type=script&lang=js"
export * from "./Invitaciones.vue?vue&type=script&lang=js"
import style0 from "./Invitaciones.vue?vue&type=style&index=0&id=469dbb9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469dbb9d",
  null
  
)

export default component.exports